import { urlToJson } from '@tencent/txv-utils';
import { bizNameMap } from '../const/business';
import {
  ApptestUrlTestValue,
  formalOriginMap,
  IwanOriginType,
  OriginEnv,
  originTypeMap,
  pagePartOriginMap,
  testOriginMap,
} from '../const/origin';
import { GetRequestOriginParams } from '../interface';

/**
 * 根据页面域名获取业务名
 * @param defaultName
 */
export function getBizName(defaultName?: string): string {
  const pageOrigin = window.location.origin;
  return Object.keys(pagePartOriginMap).find(biz => pageOrigin.includes(pagePartOriginMap[biz])) || defaultName || '';
}

// 判断游戏中心或活动是否为测试环境
export const isTestEnv = () => {
  const { apptest } = urlToJson();
  const isTest = apptest === ApptestUrlTestValue || location.href.includes('apptest.iwan.qq.com');
  return isTest;
};

/**
 * 获取请求域名设置baseUrl
 * @param params
 */
export function getRequestOrigin(params?: GetRequestOriginParams): string {
  let originMap = isTestEnv() ? testOriginMap : formalOriginMap;
  if (params?.env === OriginEnv.test) {
    originMap = testOriginMap;
  }
  if (params?.env === OriginEnv.formal) {
    originMap = formalOriginMap;
  }
  let mapName = getBizName(params?.defaultBiz);
  if (params?.iwanType === IwanOriginType.previous && mapName === bizNameMap.iwan) {
    mapName = originTypeMap.iwanPrevious;
  }

  return originMap[mapName] || window.location.origin;
}

/**
 * 如果链接上带有 traceparent 就设置到请求 header 里
 * 适配活动的观测需求
 */
export function setTraceparentInHeader(url: string, headers?: {[key: string]: string}) {
  if (!url.includes('trpc.iwan.mission_system_server.MissionSystemSvr')) {
    return headers;
  }
  const { traceparent } = urlToJson();
  if (!traceparent) {
    return headers;
  }
  return {
    ...headers || {},
    traceparent,
  };
}
